import styled from 'styled-components';

import { Text1 } from 'app/shared/ui';
import { InputBoxField } from 'app/shared/components/Formik/InputBoxField';

export const InputBoxFieldSt = styled(InputBoxField)`
  margin-bottom: -16px;
`;

export const OverlayTitleSt = styled(Text1)`
  font-size: 16px;
  line-height: 32px;
`;
